import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "p-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-bold mb-4" }, "Web Storage Explorer", -1)
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = { class: "mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loadLocalStorage && _ctx.loadLocalStorage(...args))),
          class: "bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
        }, " Load Local Storage ")
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.loadSessionStorage && _ctx.loadSessionStorage(...args))),
          class: "bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded"
        }, " Load Session Storage ")
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storageData, (value, key) => {
        return (_openBlock(), _createElementBlock("div", {
          key: key,
          class: "mb-2"
        }, [
          _createElementVNode("strong", null, _toDisplayString(key) + ":", 1),
          _createTextVNode(" " + _toDisplayString(value), 1)
        ]))
      }), 128))
    ])
  ]))
}